import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactUsComponent } from './contact-us.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ContactUsRoutes } from './contact-us.routing';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ContactUsRoutes
  ],
  declarations: [ContactUsComponent]
})
export class ContactUsModule { }
